import Global from '../../global';

// from specific to general
// ALL conditions in a rule have to be true in the SAME TIME

export default () => {
  let offeringRules = [
    {
      offering: '888de',
      conditions: {
        brands: [84]
      }
    },
    {
      offering: '888de',
      conditions: {
        brands: [0, 1, 8],
        countries: ['DEU']
      }
    },
    {
      offering: '888desh',
      conditions: {
        brands: [83]
      }
    },
    {
      offering: '888',
      conditions: {
        brands: [0, 1, 8]
      }
    },
    {
      offering: '888it',
      conditions: {
        brands: [31]
      }
    },
    {
      offering: '888es',
      conditions: {
        brands: [58]
      }
    },
    {
      offering: '888dk',
      conditions: {
        brands: [75]
      }
    },
    {
      offering: '888ro',
      conditions: {
        brands: [76]
      }
    },
    {
      offering: '888se',
      conditions: {
        brands: [81]
      }
    }
  ];

  if (Global.config.enableUKClient) {
    // this specific offering config need to be before the general one for .com
    const ukOffering = [
      {
        offering: '888uk',
        conditions: {
          brands: [0, 1, 8],
          countries: ['GBR', 'IRL']
        }
      }
    ];
    offeringRules = ukOffering.concat(offeringRules);
  }

  return {
    default: '888',
    rules: offeringRules
  };
};
